import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

import Colours from '/shared/styled/Colours';

export default function radioStyle({ $isRadio, $outline, $inverted, $active, theme }: ButtonStyleProps) {
  if ($active && $isRadio) {
    return css`
      border-color: ${Colours.green};

      * {
        color: ${Colours.white};
        line-height: 1.2;
      }
    `;
  }
  if ($outline && $isRadio) {
    return css`
      background: transparent;
      border: 1px solid ${Colours.green} !important;
      color: ${Colours.black} !important;
      line-height: 1.2;

      &:hover {
        border-color: ${$inverted ? Colours.white : Colours.greenLight2};
        opacity: 0.8;
      }
    `;
  }
  if ($isRadio) {
    return css`
      border-color: ${Colours.greyLight2};

      * {
        color: ${Colours.grey};
        line-height: 1.2;
      }
    `;
  }
}
